import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import ResultsView from 'ToolboxComponents/webapp/pages/results-view/results-view';
import Text from 'ToolboxComponents/commons/texts/text/text';


const MajorsView = ({ products, addFavorite, deleteFavorite }) => {
  return (
    <ResultsView
      products={products}
      addFavorite={event => addFavorite(event)}
      deleteFavorite={event => deleteFavorite(event)}
      hasFilters={false}
      isSelectedProduct={true}
      specialHeader= {{
        title: <Text path={`page.majors.title`} />,
        teaser: <Text path={`page.majors.description`} />,
        highlight: <Text path={`page.majors.enjoy`} />
      }}
    />
  );
};

MajorsView.propTypes = {
  products: PropTypes.array.isRequired,
  addFavorite: PropTypes.func.isRequired,
  deleteFavorite: PropTypes.func.isRequired,
};

export default MajorsView;
